import { bgConstants } from "../constants/businessGroup.constants";
import { okrDetailConstants } from "../constants/okr/okrDetails.constants";
const axios = require("axios");

export const businessgroupActions = {
  getfilterdata
};

function getfilterdata(data) {
  return dispatch => {
    showLoaderWidget($("#content"));
    const params = {
      heatMap: "2",
      status: `${okrDetailConstants.GOAL_ACTIVE},${okrDetailConstants.GOAL_CLOSED}`,
      json: "1",
      ...data
    };
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v != null)
    );
    const queryString = new URLSearchParams(filteredParams).toString();
    axios
      .get(wbConfig.baseUrl + "/goal/goalSummary?" + queryString)
      .then(function(response) {
        let bgroups = response.data;
        if (bgroups) {
          if (data.quarter !== undefined) {
            bgroups.quarter = data.quarter;
          }
          dispatch(success(bgroups));
        } else {
          console.log("Not proper format data", response);
        }
      })
      .catch(function(error) {
        console.log("error", error);
      });
  };
  function success(bgroups) {
    return { type: bgConstants.GET_BG_FILTER, bgroups };
  }
}
